import openJournalBonfire1 from "../assets/images/project_screenshots/open_journal_bonfire1.png"
import mosilysheets1 from "../assets/images/project_screenshots/mosilysheets1.png"
import videogamesales1 from "../assets/images/project_screenshots/videogamesales1.png"
import mandelbrot1 from "../assets/images/project_screenshots/mandelbrot1.png"
import conway1 from "../assets/images/project_screenshots/conway1.png" 
import pillarsVsKillers from "../assets/images/project_screenshots/pillars_vs_killers.png" 

export const projectData = {
    frontend : [
        {
            title : '"Pillars VS. Killers" Web Game',
            languagesList : ["TypeScript", "JavaScript", "PixiJS", "Howler.js", "Docker"],
            projectLink : "https://www.pillarsvskillers.ca/",
            screenshot: pillarsVsKillers,
            displayiframe : true,
            description: "A 2D strategic Tower Defense game where players must build various \"Pillars\" to fight against waves of \"Killers\" in order to win. Developed using Pixi.js, TypeScript, Howler.js, and ESLint."
        },
        {
            title : '"Open Journal Bonfire" - MERN stack Website',
            languagesList : ["Express", "Node", "SCSS", "JavaScript", "React.js", "Recharts", "MongoDB", "Mongoose", "TypeScript"],
            projectLink : "https://open-journal-bonfire.onrender.com/",
            codeLink :  "https://github.com/revive-mejett/open-journal",
            screenshot: openJournalBonfire1,
            displayiframe : true,
            description: "A web application that allows users to freely write and view anonymous journal entries, adding optional event keyword tags. Journal entry data is analyzed into data which is then visualized using Recharts library."
        },
        {
            title : '"MosilySheets" - MERN stack Website',
            languagesList : ["Responsive Web", "CSS", "JavaScript", "React.js", "Express", "Azure"],
            projectLink : "https://mosilysheets.azurewebsites.net/",
            codeLink :  "https://gitlab.com/dawson2223/620-w23/s02/team2/company-name",
            screenshot: mosilysheets1,
            displayiframe : true,
            description: "A website aimed to people interested in electrical projects view related electrical components, comment, and make projects that require certain electrical components."
        },
        {
            title : "Mandelbrot Set",
            languagesList : ["React.js (my contribution of collab)"],
            projectLink : "https://revive-mejett.github.io/mandelbrot-set/",
            codeLink :  "https://github.com/revive-mejett/mandelbrot-set",
            screenshot: mandelbrot1,
            displayiframe : true,
            description: "Simulates a mathematical fractal with panning and zomming interactive"
        },
        {
            title : "Conway's Game of Life Simulation",
            languagesList : ["HTML", "CSS", "Vanilla JavaScript"],
            projectLink : "https://revive-mejett.github.io/conway-game-life-sim/",
            codeLink :  "https://github.com/revive-mejett/conway-game-life-sim",
            screenshot: conway1,
            displayiframe : true,
            description: "Replication and Simulation of John Horton Conway's cellular automaton algorithm in JavaScript"
        },
        {
            title : "Memory Tiles Game",
            languagesList : ["HTML", "CSS", "Vanlilla JavaScript"],
            projectLink : "https://revive-mejett.github.io/revive-mejett/",
            codeLink :  "https://github.com/revive-mejett/revive-mejett",
            displayiframe : true,
            description: "Tiles sequence game involving memorization."
        }
    ],
    other : [
        {
            title : "Robby The Robot Simulation",
            languagesList : ["C#",".NET"],
            projectLink : undefined,
            codeLink :  undefined,
            displayiframe : false,
            description: "Uses a concept of a Genetic Algorithm to evolve a robot named \"Robby\" that moves in a grid filled with cans"
        },
        {
            title : "Video game sales MERN stack",
            languagesList : ["CSS", "JavaScript", "React.js (my contribution of collab)"],
            projectLink : "https://video-game-sales.onrender.com/",
            codeLink :  "https://gitlab.com/dawson2223/section02/project/team02/520-project-ivan-marshment-veloso",
            screenshot: videogamesales1,
            displayiframe : true,
            description: "Displays video game sales data comparison with React. Did the frontend portion of the MERN stack"
        },
        {
            title : "Piano Simulation with Monogame",
            languagesList : ["C#"],
            projectLink : undefined,
            codeLink :  "https://gitlab.com/Kyle_V/progv-assignment2-pianomonogame",
            displayiframe : false,
            description: "Simulates a mini piano using C# and Monogame game framework."
        },
    ]
}